import * as React from 'react';

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField';


export default function CharismaCertificationItemForm(props){
    
    const [title, setTitle] = React.useState(props.title);
    const [nError, setNError] = React.useState(0);
    const [wait, setWait] = React.useState(false);
    
    function handleSubmit(){
        const lValidTitle: boolean = title.length > 0;
        if(!lValidTitle){
            setNError(1);
        }
        else if(props.id === undefined){
                setWait(true);
                props.handleSubmit(title);
        }
        else{
            setWait(true);
            props.handleSubmit(title, props.id);
        }
        
    }
    
    return(
        <Dialog
            open={true}
        >
            <DialogTitle>
                {props.title === undefined ?
                    "Modification d'item"
                    :
                    "Ajout d'un item de certification"
                }
            </DialogTitle>
            <DialogContent>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="name"
                    label="Nom"
                    name="fName"
                    autoFocus
                    error={nError > 0}
                    helperText={nError > 0 ? 'Titre invalide' : null}
                    value={title}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setTitle(event.target.value);
                        setNError(0);
                    }}
                />
              
                {wait ?
                    <Alert severity='info'>{props.id === undefined ? "Création de l'item en cours" : "Modification en cours"}</Alert>
                    :
                    null
                }
            </DialogContent>
            <DialogActions>
                <Button disabled={wait} onClick={()=>handleSubmit()}>Valider</Button>
                <Button disabled={wait} onClick={()=>props.handleCancel()}>Annuler</Button>
            </DialogActions>
        </Dialog>        
    );
}